import { wixProductParams } from "../../models/types/wixProduct.types";
import { authAxios } from "../default";

export const wixApi = {
  /*
  |--------------------------------------------------------------------------
  | Fetches all the Wix Products Based on provided parameters
  |--------------------------------------------------------------------------
  |
  */
  fetchProducts: async (params: wixProductParams): Promise<any> => {
    return authAxios.get("/api/products/wix", {
      params: params,
    });
  },

  /*
  |--------------------------------------------------------------------------
  | Fetch all products related to the collections
  |--------------------------------------------------------------------------
  |
  */
  fetchCollectionProducts: async (collectionId: number): Promise<any> => {
    return authAxios.get("/api/products/wix", {
      params: {
        collectionId,
      },
    });
  },

  /*
  |--------------------------------------------------------------------------
  | Fetch all the Collections from Wix 
  |--------------------------------------------------------------------------
  |
  */
  fetchCollection: async (name: string, page: number): Promise<any> => {
    return authAxios.get("/api/collections/wix", {
      params: {
        name,
        page,
      },
    });
  },

  /*
  |--------------------------------------------------------------------------
  | Import Products from Wix to our store
  |--------------------------------------------------------------------------
  |
  */
  importProducts: async (): Promise<any> => {
    return authAxios.post("/api/products/wix/import");
  },

  /*
  |--------------------------------------------------------------------------
  | Import Collections from Wix to our store
  |--------------------------------------------------------------------------
  |
  */
  importCollections: async (): Promise<any> => {
    return authAxios.post("/api/collections/wix/import");
  },

  /*
  |--------------------------------------------------------------------------
  | Fetches Product Count Based on their Statuses
  |--------------------------------------------------------------------------
  |
  */
  fetchProductsCount: async (): Promise<any> => {
    return authAxios.get("/api/products/wix/count");
  },

  /*
  |--------------------------------------------------------------------------
  | Delete Product From Wix
  |--------------------------------------------------------------------------
  |
  */
  deleteProductFromWix: async (productId: string): Promise<any> => {
    return authAxios.delete(`/api/products/wix/${productId}`);
  },

  /*
  |--------------------------------------------------------------------------
  | Retrieve Wix Store Details
  |--------------------------------------------------------------------------
  |
  */
  fetchStoreDetail: async (): Promise<any> => {
    return authAxios.get("/api/dashboard/wix/detail");
  },
};
